import { createTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';
import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import upperCase from 'lodash';

const mapOverridesToComponents = (themeOverrides) =>
  Object.keys(themeOverrides).reduce((components, componentName) => {
    components[componentName] = {
      styleOverrides: themeOverrides[componentName],
    };

    return components;
  }, {});

// material ui needs to set local to itIT for italian enUS for english
let localeMaterial = `${localStorage.i18nextLng}${upperCase(
  localStorage.i18nextLng,
)}`;
localeMaterial === 'enEN' ? (localeMaterial = 'enUS') : localeMaterial;

const theme = createTheme(
  {
    palette,
    typography,
    overrides,
    components: mapOverridesToComponents(overrides),
  },
  locales[localeMaterial],
);

export default theme;
